import {
  QueryClient,
  type QueryClientConfig,
  VueQueryPlugin,
} from "@tanstack/vue-query";

import type { AdminApp } from "@/misc/types";

export default function queryClientPlugin(
  app: AdminApp,
  options?: QueryClientConfig,
) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 10, // 1000ms * 10
      },
    },
    ...options,
  });

  app.use(VueQueryPlugin, {
    queryClient,
  });

  app.config.globalProperties.$queryClient = queryClient;
}
